import {Component} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router, ActivatedRoute} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {ItemsService} from '../../../Services/items.service';
import {UserType} from '../../../Shared/Enums/UserType';
import {AuthService} from '../../../Shared/Services/auth.service';
import {CustomToastrService} from '../../../Shared/Services/custom-toastr.service';
import {DialogService} from '../../../Shared/Services/dialog.service';
import {SharedService} from '../../../Shared/Services/shared.service';
import {itemsVM} from '../../../Model/items/itemsVM';
import {environment} from '../../../../environments/environment'
import {takeUntil} from 'rxjs/internal/operators/takeUntil';
import {Subject} from 'rxjs/internal/Subject';
import {categoryVM} from '../../../Model/items/categoryVM';
import {colorVM} from '../../../Model/items/colorVM';
import {TypeOfProductVm} from '../../../Model/items/TypeOfProductVm';
import {LoginVm} from '../../../Model/LoginVM';
import {DtoAgentVM} from "../../../Model/agents/DtoAgentVM";
import {SuppliersService} from "../../../Services/suppliers.service";
import {forkJoin} from "rxjs";

@Component({
  selector: 'app-add-item',
  templateUrl: './add-item.component.html',
  styleUrl: './add-item.component.scss'
})
export class AddItemComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  currentUser: LoginVm = {};
  form!: FormGroup;
  fileUpload: any;//FileList
  imgURL?: string;
  CategoryList!: categoryVM[];
  ColorList!: colorVM[];
  TypeOfProductList!: TypeOfProductVm[];
  Suppliers: DtoAgentVM[] = [];
  isEdit?: boolean = false;

  constructor(private api: ItemsService, private supplierApi: SuppliersService, private router: Router,
              private toastrService: CustomToastrService, private auth: AuthService,
              private spinner: NgxSpinnerService, private dialogService: DialogService,
              private route: ActivatedRoute, private shared: SharedService) {
  }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Agent])) {
      this.spinner.show();
      this.GetCurrentUser();
      this.initForm();
      this.GetLookups();
      this.isEdit = false;
      this.route.params.subscribe(params => {
        const id = params['id'];
        if (id) {
          this.isEdit = true;
          this.GetItemData(id);
        }
      });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetCurrentUser() {
    let jsonObj = this.auth.getStorage("currentUser");
    this.currentUser = <LoginVm>JSON.parse(jsonObj);
  }

  GetItemData(itemId: any) {
    if (this.auth.isAuthenticated([UserType.Agent])) {
      this.api.GetItemData(itemId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: any) => {
            this.spinner.hide();
            if (data.isSuccess) {
              this.setFormValue(data.payload);
            }
          },
          error: (error: any) => {
            this.spinner.hide();
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  initForm() {
    this.form = new FormGroup({
      productId: new FormControl('', []),
      supplierId: new FormControl('', [Validators.required]),
      colorId: new FormControl('', []),
      categoryId: new FormControl('', [Validators.required]),
      productCode: new FormControl('', [Validators.required]),
      metersPerRod: new FormControl('', [Validators.required]),
      typeOfProductName: new FormControl('', [Validators.required]),
      totalQuota: new FormControl('', [Validators.required]),
      pricePerOne: new FormControl('', [Validators.required]),
      productName: new FormControl('', [Validators.required]),
      haveDescount: new FormControl(''),
      haveColor: new FormControl(''),
      imgURL: new FormControl('', [Validators.required])
    });

    this.form.controls["haveColor"].valueChanges.subscribe(value => {
      if (!value) {
        this.form.controls["colorId"].setValue('');
        this.form.controls["colorId"].setValidators([]);
      } else {
        this.form.controls["colorId"].setValidators([Validators.required]);
      }
    });
  }

  GetFileUpload() {
    const img = this.fileUpload;
    if (img != undefined) {
      this.form.setValue({
        imgURL: img.name,
        supplierId: this.form.value.supplierId,
        productId: this.form.value.productId,
        colorId: this.form.value.colorId,
        categoryId: this.form.value.categoryId,
        productCode: this.form.value.productCode,
        metersPerRod: this.form.value.metersPerRod,
        typeOfProductName: this.form.value.typeOfProductName,
        totalQuota: this.form.value.totalQuota,
        pricePerOne: this.form.value.pricePerOne,
        productName: this.form.value.productName,
        haveDescount: this.form.value.haveDescount,
        haveColor: this.form.value.haveColor
      });
      this.form.updateValueAndValidity();
    }
  }

  onFileSelected(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.result != null) {
          this.imgURL = reader.result.toString();
          this.fileUpload = file;
          this.GetFileUpload();
        }
      };
      reader.readAsDataURL(file);
    }
  }

  setFormValue(data: itemsVM) {
    this.form.setValue({
      productId: data.productId,
      supplierId: data.supplierId,
      imgURL: data.imgURL,
      colorId: data.colorId,
      categoryId: data.categoryId,
      productCode: data.productCode,
      metersPerRod: data.metersPerRod,
      typeOfProductName: data.typeOfProductName,
      totalQuota: data.totalQuota,
      pricePerOne: data.pricePerOne,
      productName: data.productName,
      haveDescount: data.haveDescount,
      haveColor: data.haveColor
    });

    if (data.imgURL) {
      this.form.controls["imgURL"].setValue(data.imgURL);
      this.imgURL = environment.ImgUrl + "/" + data.imgURL;
    }
  }

  get f() {
    return this.form.controls;
  }

  GetLookups() {
    if (this.auth.isAuthenticated([UserType.Agent])) {
      let requests = [this.supplierApi.GetAllSuppliers(), this.api.GetAllCategoryForDrop(), this.api.GetAllColors(), this.api.GetTypeOfProduct()];
      forkJoin(requests).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res: any) => {
          this.Suppliers = res[0].result.payload;
          this.CategoryList = res[1].payload;
          this.ColorList = res[2].payload;
          this.TypeOfProductList = res[3].payload;
          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
          this.toastrService.showErrorToast('Error', "SomethingWentWrong");
        }
      });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }
  submit() {
    if (this.form.valid) {
      this.dialogService.confirmDialog({
        titleKey: 'confirmation',
        messageKey: 'AreYouSuretoSaveThis',
        confirmTextKey: 'Yes',
        cancelTextKey: 'No'
      }).subscribe(isConfirmed => {
        if (isConfirmed) {
          this.AddNewItem(this.form.value);
        }
      });
    } else {
      this.shared.FireFormValidation(this.form);
    }
  }

  AddNewItem(form: any) {
    this.spinner.show();
    const formData = new FormData();
    if (this.fileUpload) {
      const img = this.fileUpload;
      if (img != undefined) {
        formData.append('Photo', img);
      }
    }

    formData.append('colorId', form.colorId);
    formData.append('supplierId', form.supplierId);
    formData.append('productCode', form.productCode);
    formData.append('categoryId', form.categoryId);
    formData.append('haveColor', (form.haveColor) ? ("true") : ("false"));
    formData.append('haveDescount', (form.haveDescount) ? ("true") : ("false"));
    formData.append('productName', form.productName);
    formData.append('metersPerRod', form.metersPerRod);
    formData.append('typeOfProductName', form.typeOfProductName);
    formData.append('totalQuota', form.totalQuota);
    formData.append('pricePerOne', form.pricePerOne);

    if (form.productId) {
      formData.append('productId', form.productId);
      this.EditItem(formData);
    } else {
      this.AddItem(formData);
    }
  }

  AddItem(formData: FormData) {
    this.api.AddNewItem(formData).pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: (data: any) => {
            this.spinner.hide();
            if (data.isSuccess) {
              this.toastrService.showSuccessToast('Success', 'AddedSuccessfully');
              setTimeout(() => {
                this.router.navigateByUrl('dashboard/items');
              }, 600);
            } else {
              this.toastrService.showErrorToast('Error', data.message);
            }
          },
          error: (error: any) => {
            this.spinner.hide();
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        });
  }


  EditItem(formData: FormData) {
    this.api.EditItem(formData).pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: (data: any) => {
            this.spinner.hide();
            if (data.isSuccess) {
              this.toastrService.showSuccessToast('Success', 'EditedSuccessfully');
              setTimeout(() => {
                this.router.navigateByUrl('dashboard/items');
              }, 600);
            } else {
              this.toastrService.showErrorToast('Error', data.message);
            }
          },
          error: (error: any) => {
            this.spinner.hide();
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        });
  }

  Cancel() {
    if (this.form.touched) {
      this.dialogService.confirmDialog({
        titleKey: 'confirmation',
        messageKey: 'AreYouSuretoBackWithoutSave',
        confirmTextKey: 'Yes',
        cancelTextKey: 'No'
      }).subscribe(isConfirmed => {
        if (isConfirmed) {
          this.router.navigateByUrl('dashboard/items');
        }
      });
    } else {
      this.router.navigateByUrl('dashboard/items');
    }
  }
}
